import { 
    REGISTRO_EXITOSO,
    REGISTRO_ERROR,
    REGISTRO_PASSWORD,
    ACTUALIZAR_USUARIO,
    ACTUALIZAR_USUARIO_POR_EMAIL,
    OBTENER_USUARIO,
    LOGIN_EXITOSO,
    LOGIN_ERROR,
    CERRAR_SESION
} from '../../types';

const reducer =  (state, action) => {
    switch(action.type) {
        case REGISTRO_EXITOSO:
        case LOGIN_EXITOSO:
            localStorage.setItem('token', action.payload.token);
            return {
                ...state,
                autenticado: true,
                usuario: action.payload,
                mensaje: null,
                cargando: false
            }
        case OBTENER_USUARIO: 
            return {
                ...state,
                autenticado: true,
                usuario: action.payload,
                cargando: false
            }
        case CERRAR_SESION:
        case LOGIN_ERROR:
        case REGISTRO_ERROR:
            localStorage.removeItem('token');
            return {
                ...state,
                token: null,
                usuario: null,
                autenticado: null,
                mensaje: action.payload, 
                cargando: false
            }
        case REGISTRO_PASSWORD:
            return {
                mensaje: action.payload
            }
        case ACTUALIZAR_USUARIO:
            return {
                ...state,
                usuario: action.payload
            }
        case ACTUALIZAR_USUARIO_POR_EMAIL:
            return {
                ...state,
                usuario: action.payload
            }
        default:
            return state;
    }
}

export default reducer;